<template>
  <section>
    <v-container fluid>
      <v-row justify="start" align="center">
        <v-col cols="auto">
          <v-btn
            @click="handleOpenDialog()"
            class="accent shadow-4 px-8"
            color="success"
            large
            rounded
          >
            Crear Boton
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-row class="mt-10">
      <v-col cols="12">
        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
          :loading="isLoading"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
        >
          <template v-slot:[`item.token`]="{ item }">
            <pre class="mr-3">{{ item.token }}</pre>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="handleOpenDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'error' : 'blue-grey'"
                @click.stop="handleOpenDelete(item)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-hover>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <call-buttons-form
      :dialogProp="isOpenFormDialog"
      :mode="itemSelected ? 'edit' : 'register'"
      :dataToForm="itemSelected || {}"
      @dialog:close="handleCloseDialog"
    ></call-buttons-form>
    <delete-call-button
      :dialogProp="isOpenDelete"
      :item="itemSelected || {}"
      @dialog:close="handleCloseDelete"
    ></delete-call-button>
  </section>
</template>

<script>
import moment from "moment";
import { PbxHttpClient } from "@/services/httpclient";
import CallButtonsForm from "@/components/CallButtons/CallButtonsForm.vue";
import DeleteCallButton from "@/components/CallButtons/DeleteCallButton.vue";

export default {
  components: {
    CallButtonsForm,
    DeleteCallButton,
  },
  data() {
    return {
      isLoading: true,
      totalItems: 0,
      isOpenFormDialog: false,
      isOpenDelete: false,
      itemSelected: null,
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      tableHeaders: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          width: "10%",
        },
        {
          text: "cantidad",
          align: "left",
          value: "quantity",
          width: "10%",
        },
        {
          text: "Costo",
          align: "left",
          value: "cost",
          width: "10%",
        },
        {
          text: "Fecha",
          align: "left",
          value: "created_at",
          width: "15%",
        },
        {
          text: "A Responder",
          align: "left",
          value: "to_respond",
          width: "13%",
        },
        {
          text: "Token",
          align: "left",
          value: "token",
          width: "10%",
        },
        {
          text: "Estatus",
          align: "left",
          value: "status",
          width: "10%",
        },
        {
          text: "Tiempo",
          align: "left",
          value: "time_use_minutes",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "action",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      tableData: [],
    };
  },

  watch: {
    tableOptions: {
      handler() {
        this.getInfo();
      },
      deep: true,
    },
  },

  methods: {
    async getInfo() {
      this.isLoading = true;
      const page = this.tableOptions.page || 1;
      const itemPerPage = this.tableOptions.itemsPerPage || 15;
      try {
        const { data } = await PbxHttpClient.get(`/admin/call_button`, {
          params: { page, itemPerPage },
        });
        this.totalItems = data.total;
        this.tableData = data.data;
      } catch (err) {
        console.log("err", err);
      }
      this.isLoading = false;
    },

    handleCloseDialog(data = null) {
      this.isOpenFormDialog = false;
      if (!data) {
        this.itemSelected = null;
        return;
      }

      if (!this.itemSelected) {
        this.tableData = [...this.tableData, data];
        this.totalItems += 1;
      } else
        this.tableData = this.tableData.map((item) =>
          item.id === data.id ? data : item
        );

      this.itemSelected = null;
    },

    handleOpenDialog(data = null) {
      if (data) this.itemSelected = data;
      this.isOpenFormDialog = true;
    },

    handleOpenDelete(item) {
      this.isOpenDelete = true;
      this.itemSelected = item;
    },

    handleCloseDelete(itDelete) {
      if (itDelete)
        this.tableData = this.tableData.filter(({ id }) => id !== this.itemSelected.id);
      this.isOpenDelete = false;
      this.itemSelected = null;
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>
